module.exports = __webpack_public_path__ + "static/media/fb-small.c073d65f.webp";